export default {
  "locale": {
    "label": "Language",
    "switchSuccess": "Language switched successfully",
    "zhCN": "简体中文",
    "zhTW": "繁體中文",
    "en": "English"
  },
  "login": {
    "welcome": "Welcome",
    "title": "EV Charging Merchant Management Platform",
    "usernamePlaceholder": "Please enter username",
    "passwordPlaceholder": "Password",
    "captchaPlaceholder": "Verification code",
    "loginBtn": "Login",
    "agreePrefix": "I have read and agree to the ",
    "userAgreement": "User Agreement",
    "accountLogin": "Account Login",
    "usernameRequired": "Username cannot be empty!",
    "passwordRequired": "Password cannot be empty!",
    "agreementRequired": "Please agree to the User Agreement",
    "loginSuccess": "Login successful",
    "fetchUserInfoFailed": "Failed to fetch user info, please try again"
  },
  "error":{
    "wechatTip": "Please open this link within the WeChat browser",
  },
  "advert": {
    "title": "Ad Title",
    "url": "Link URL",
    "showPage": "Display Placement",
    "uploadImage": "Upload Image",
    "showPage_tip_1": "QR Code Scanned Successfully",
    "showPage_tip_2": "Charging Started",
    "showPage_tip_3": "Feedback",
    "showPage_tip_4": "Order List",
    "uploadImageTip_1": "Images must be in JPG format!",
    "uploadImageTip_2": "Image size cannot exceed 2MB!",
    "success": "Updated successfully",
    "addSuccess": "Added successfully",
    "deleteSuccess": "Deleted successfully",
    "noData": "No ad records available",
    "addNotice": "Add New Ad",
    "siteName": "Station Name",
  },
  "card": {
    "cardNo": "Card No.",
    "physicalCardNo": "Physical Card No.",
    "sum": "Balance",
    "mobile": "Phone",
    "realName": "Agent",
    "save": "Save",
    "selectOperator": "Please select an agent",
    "inputCardNo": "Please enter card number",
    "inputPhysicalCardNo": "Please enter physical card number",
    "inputSum": "Please enter balance",
    "inputMobile": "Please enter phone number",
    "cardNoError": "Please enter card letters (ABCDEF) + numbers (0-9)",
    "inputTip": "Please enter ",
    "inputLegalAmount": "Please enter a valid amount",
    "inputPhone": "Please enter a valid phone number",
    "editCard": "Edit Card",
    "addCard": "Add Card",
    "addCardFailed": "Failed to add card",
    "editCardFailed": "Failed to edit card",
    "card_1": "Enter Card No. / Phone No.",
    "card_2": "No IC cards found",
    "card_3": "Please click the 'Add' button on the right",
    "card_4": "to start your operations!",
    "card_5": "Add",
    "card_6": "All Cards",
    "card_7": "Card No.: ",
    "card_8": "User Phone",
    "card_9": "Card Balance",
    "card_10": "Binding Date",
    "card_11": "Report Loss",
    "card_12": "Top-up Records",
    "card_13": "Usage Records",
    "card_14": "Are you sure you want to report this card as lost?",
    "card_15": "Let me think",
    "card_16": "Unknown",
    "card_17": "None",
    "card_18": "All data loaded",
    "card_19": "No data available",
    "card_20": "Failed to fetch data",
    "card_21": "This card has been reported lost",
    "card_22": "Reported lost successfully",
    "card_23": "Failed to report loss",
    "card_24": "Create New",
    "card_25": "Filter",
    "card_26": "Username",
    "card_27": "Unbound",
    "card_28": "Phone",
    "card_29": "None",
    "card_30": "Status",
    "card_31": "No cards found",
    "card_32": "Normal",
    "card_33": "Lost",
    "card_34": "Not Activated",
    "card_35": "Add Card",
    "card_36": "Card ID",
    "card_37": "Please enter number",
    "card_38": "Card number cannot be empty",
    "card_39": "Balance cannot be empty",
    "card_40": "Phone number cannot be empty",
    "card_41": "Incorrect phone number, please re-enter",
    "card_42": "Are you sure you want to report this card as lost?",
    "card_43": "Cancel Loss Report",
    "card_44": "Search Card No. / Phone No.",
    "card_45": "Actions",
    "card_46": "Time",
    "card_47": "No more data",
    "card_48": "",
    "card_49": "Card ID: ",
    "card_50": "No top-up records found",
    "card_51": "Top-up ",
    "card_52": "Expense",
    "card_53": "Reward",
    "card_54": "System Top-up",
    "card_55": "Refund",
    "card_56": "Refund failed",
    "card_57": "Transfer",
    "card_58": "Amount",
    "card_59": "Date",
    "card_60": "Actual Time",
    "card_61": "Estimated Time",
    "card_62": "Charging Pile ID",
    "card_63": "No usage records found",
    "card_64": "Card number must be digital!",
    "card_65": "You've reached the bottom",
    "card_66": "More",
    "card_67": "View",
    "card_68": "Recharge",
    "card_69": "Bind User",
    "card_70": "Unbind User",
    "card_71": "Reissue Card",
    "card_72": "Card Details",
    "card_73": "Recharge Amount",
    "card_74": "Please enter recharge amount",
    "card_75": "Recharge successful",
    "card_76": "Recharge failed",
    "card_77": "New Card No.",
    "card_78": "Please enter new card number",
    "card_79": "Reissue successful",
    "card_80": "Reissue failed",
    "card_81": "Are you sure to delete this card?",
    "card_82": "Deleted successfully",
    "card_83": "Delete failed",
    "card_84": "Are you sure to unbind this user?",
    "card_85": "Unbound successfully",
    "card_86": "Unbind failed",
    "card_87": "Cancel loss successful",
    "card_88": "Cancel loss failed",
    "card_89": "Bind successful",
    "card_90": "Bind failed",
  },  
  "equip": {
    "equip_1": "You haven't added any devices yet",
    "equip_2": "Please click the 'Add Device' button below",
    "equip_3": "All Devices",
    "equip_4": "Running",
    "equip_5": "Offline",
    "equip_6": "Total Earnings",
    "equip_7": "Energy",
    "equip_8": "Sessions",
    "equip_9": "Duration",
    "equip_10": "Rule Settings",
    "equip_11": "Select Rule",
    "equip_12": "Please select a rule",
    "equip_13": "Edit",
    "equip_14": "All",
    "equip_15": "Port",
    "equip_16": "Rule",
    "equip_17": "Earnings",
    "equip_18": "Edit",
    "equip_19": "Add Device",
    "equip_20": "Community Name / Device ID",
    "equip_21": "Unit(s)",
    "equip_22": "Charging Pile ID",
    "equip_23": "No devices found",
    "equip_24": "Charging Pile Code",
    "equip_25": "Charging Pile Name",
    "equip_26": "Charging Pile Type",
    "equip_27": "Gun Quantity",
    "equip_28": "Current (A)",
    "equip_29": "Voltage (V)",
    "equip_30": "Power (kW)",
    "equip_31": "SIM Card Serial Number",
    "equip_32": "SIM Card Expiration Time",
    "equip_33": "Please select",
    "equip_34": "Station",
    "equip_35": "Save",
    "equip_portType": "Gun Type",
    "equip_portType_1": "Single Gun",
    "equip_portType_2": "Dual Gun",
    "equip_portType_8": "1-to-8",
    "equip_portType_10": "1-to-10",
    "equip_portType_16": "1-to-16",
    "equip_portType_tip": "Please select gun type",
    "equip_supply": "Manufacturer Device Model",
    "equip_supply_tip": "Please select manufacturer device model",
    "equip_cpFeeType": "Billing Type",
    "equip_cpFeeType_charge": "Charge",
    "equip_cpFeeType_free": "Free",
    "equip_protocolType": "Protocol Type",
    "equip_protocolType_tip": "Please select protocol type",
    "equip_36": "Please select datetime",
    "equip_37": "Please enter a correct value",
    "equip_38": "Please enter charging pile ID",
    "equip_39": "Charging pile ID must be 14 digits",
    "equip_40": "Please enter current",
    "equip_41": "Please enter voltage",
    "equip_42": "Please enter max power",
    "equip_43": "Please enter charging pile name",
    "equip_44": "Please enter port quantity",
    "equip_45": "Please select charging pile type",
    "equip_46": "Please select status",
    "equip_48": "Please select station",
    "equip_49": "Edit Device",
    "equip_50": "Saved successfully",
    "equip_51": "Failed to save",
    "equip_52": "API Error",
    "equip_53": "Level 1/2 Charging (Slow)",
    "equip_54": "DC Fast Charging",
    "equip_pileType_0": "Medium (3.5-7kW)",
    "equip_pileType_1": "Fast (11-22kW)",
    "equip_pileType_2": "Super Fast (40-60kW)",
    "equip_pileType_3": "Ultra Fast (120kW)",
    "equip_55": "Disabled",
    "equip_56": "Enabled",
    "equip_pileAccess": "Pile Access Type",
    "equip_pileAccess_0": "Public Device",
    "equip_pileAccess_1": "Fixed Device",
    "equip_pileAccess_tip": "Please select pile access type",
    "equip_57": "Device ID",
    "equip_58": "Device Name",
    "equip_59": "SIM Card",
    "equip_60": "Deployment Address",
    "equip_61": "Province",
    "equip_62": "City",
    "equip_63": "District",
    "equip_64": "Community Details",
    "equip_65": "Device Type",
    "equip_66": "Operation Status",
    "equip_67": "Please select region",
    "equip_68": "Please select community",
    "equip_69": "Please select fee type",
    "equip_70": "Please select operation status",
    "equip_71": "No community data for this region",
    "equip_72": "Enter custom community",
    "equip_73": "Please enter a valid charging pile ID",
    "equip_74": "Please enter charging pile name",
    "equip_75": "Please select community for charging pile",
    "equip_76": "Please select fee type for charging pile",
    "equip_77": "Total Earnings (HKD)",
    "equip_78": "Charged Energy (kWh)",
    "equip_79": "Charging Duration (Hours)",
    "equip_80": "Edit Port",
    "equip_81": "Edit Name",
    "equip_82": "Port Status",
    "equip_83": "Please select port status",
    "equip_84": "Offline",
    "equip_85": "Faulty",
    "equip_86": "Idle",
    "equip_87": "Charging",
    "equip_88": "Plugged In",
    "equip_89": "Occupied",
    "equip_90": "Action successful",
    "equip_91": "Action failed",
    "equip_92": "This port is currently in use and cannot be edited",
    "equip_93": "Please fill in port name",
    "equip_94": "Port edited successfully",
    "equip_95": "Total Power Consumption",
    "equip_96": "No time data",
    "equip_97": "No ports found",
    "equip_98": "Add Port",
    "equip_99": "Port Name",
    "equip_100": "Please enter port name",
    "equip_101": "In Use",
    "equip_102": "Port deleted successfully",
    "equip_103": "Official Account Rules",
    "equip_104": "Edit Selected Rule",
    "equip_105": "Card Rules",
    "equip_106": "Please select Official Account rule",
    "equip_107": "Please select card rule",
    "equip_108": "Please select a rule first",
    "equip_109": "Please select public rule",
    "equip_110": "Rules set successfully",
    "equip_111": "Online",
    "equip_112": "Offline",
    "equip_113": "Consumed Energy",
    "equip_114": "kWh",
    "equip_115": "Electricity Fee",
    "equip_116": "Service Fee",
    "equip_117": "Hours",
    "equip_118": "Rule Name",
    "equip_119": "Charging pile ID must be 8 digits",
    "equip_120": "Current",
    "equip_121": "Voltage",
    "equip_122": "Max Power",
    "equip_123": "Save Edits",
    "equip_124": "Add Now",
    "equip_125": "Please enter digits",
    "equip_126": "Please enter card serial number",
    "equip_127": "Please select expiration time",
    "equip_128": "Turn On",
    "equip_129": "Turn Off",
    "equip_130": "Port added successfully",
    "equip_131": "Total Equipment Revenue",
  },
  "equipment":{
    "equipment_1": "Earnings Breakdown",
    "equipment_2": "Total (HKD)",
    "equipment_3": "No records found",
    "equipment_4": "Please enter order number",
    "equipment_5": "Earnings",
    "equipment_6": "Total Revenue",
    "equipment_7": "Order Quantity",
    "equipment_8": "Order ID",
    "equipment_9": "Start Time",
    "equipment_10": "End Time",
    "equipment_11": "No order records found",
    "equipment_12": "My Earnings",
    "equipment_13": "User Spending",
    "equipment_14": "All",
    "equipment_15": "Consumed Energy",
    "equipment_16": "Refund Amount",
    "equipment_17": "Tissue Pack Purchase",
    "equipment_18": "Card Payment Amount",
    "equipment_19": "Usage Duration",
    "equipment_20": "Spending Amount",
    "equipment_21": "Actual Spending",
    "equipment_22": "Offline Coin-op",
    "equipment_23": "Prepaid Card",
    "equipment_24": "Advertisement",
    "equipment_25": "Top-up",
    "equipment_26": "Account Balance",
    "equipment_27": "Withdraw Now",
    "equipment_28": "Dashboard",
    "equipment_29": "This Month's Earnings",
    "equipment_30": "Today's Earnings",
    "equipment_31": "Completed Orders",
    "equipment_32": "Total Devices",
    "equipment_33": "Total Device Power Consumption",
    "equipment_34": "Billing Details",
    "equipment_35": "Location Analytics",
    "equipment_36": "Time Analytics",
    "equipment_37": "Total Monthly Earnings",
    "equipment_38": "Online Payment",
    "equipment_39": "Card Payment",
    "equipment_40": "Online",
    "equipment_41": "Offline",
  },
  "mine":{
    "mine_1": "Common Features",
    "mine_2": "Business Data",
    "mine_3": "All Stations",
    "mine_4": "All Time",
    "mine_5": "Clear",
    "mine_6": "Total Earnings",
    "mine_7": "Total Revenue",
    "mine_8": "Electricity Fee",
    "mine_9": "Service Fee",
    "mine_10": "Running",
    "mine_11": "Offline",
    "mine_12": "Total Volume",
    "mine_13": "Electricity Fee",
    "mine_14": "Service Fee",
    "mine_15": "Energy (kWh)",
    "mine_16": "Charging Count",
    "mine_17": "Station",
    "mine_18": "Device",
    "mine_19": "Order",
    "mine_20": "IC Card",
    "mine_21": "Rule",
    "mine_22": "User",
    "mine_23": "Feedback",
    "mine_24": "Share Sum",
    "mine_25": "Community",
    "mine_26": "IC Card",
    "mine_27": "Withdrawal Records",
    "mine_28": "Current Balance (HKD)",
    "mine_29": "Withdrawable Balance (HKD)",
    "mine_30": "Platform Frozen Amount (HKD)",
    "mine_31": "Withdrawal Account",
    "mine_32": "Withdrawal Amount",
    "mine_33": "Withdraw All",
    "mine_34": "Min Withdrawal Amount",
    "mine_35": "Withdrawal Fee For This Transaction",
    "mine_36": "Auto Withdrawal",
    "mine_37": "Yes",
    "mine_38": "Minimum Charge",
    "mine_39": "Handling Fee",
    "mine_40": "Upload Invoice",
    "mine_41": "PDF only, max 500KB per file, up to 3 files",
    "mine_42": "Withdraw",
    "mine_43": "Withdrawal Notice",
    "mine_44": "Actual Payout Amount",
    "mine_45": "Confirm Withdrawal",
    "mine_46": "Let me think",
    "mine_47": "Withdrawal amount must be greater than 0",
    "mine_48": "Withdrawal amount can have at most two decimal places",
    "mine_49": "Withdrawal amount cannot exceed withdrawable balance",
    "mine_50": "Withdrawal amount cannot be less than the minimum required",
    "mine_51": "Actual payout: {actual_money}, handling fee: {transFree}",
    "mine_52": "Withdrawal in progress",
    "mine_53": "You can upload a maximum of 3 invoices",
    "mine_54": "Only PDF files are supported",
    "mine_55": "File size cannot exceed 500KB",
    "mine_56": "Uploading...",
    "mine_57": "Upload failed",
    "mine_58": "Your operator profile has not configured Official Account information correctly",
    "mine_59": "Linked successfully",
    "mine_60": "Welcome back, ",
    "mine_61": "Enter Dashboard",
    "mine_62": "Created Time",
    "mine_63": "Bike/Scooter",
    "mine_64": "Car",
    "mine_65": "Accumulated Earnings",
    "mine_66": "Today's Earnings",
    "mine_67": "Account Balance",
    "mine_68": "Go to Withdrawal",
    "mine_69": "This Month's Earnings",
    "mine_70": "Operation Statistics",
    "mine_71": "Transaction Amount",
    "mine_72": "",
    "mine_73": "Total Order Amount",
    "mine_74": "My Revenue Share",
    "mine_75": "View Share Details",
    "mine_76": "Revenue Share Analytics",
    "mine_77": "Accumulated Amount",
    "mine_78": "Past Week",
    "mine_79": "Past Month",
    "mine_80": "Past Year",
    "mine_81": "Accumulated Energy (kWh)",
    "mine_82": "Refund Amount",
    "mine_83": "Order Count",
    "mine_84": "Registered Users (People)",
    "mine_85": "Amount",
    "mine_86": "Active",
    "mine_87": "Offline",
    "mine_88": "Current withdrawable balance is 0, cannot withdraw",
    "mine_89": "Top-up Amount",
    "mine_90": "Refund Amount",
    "mine_91": "Refund Amount",
    "mine_92": "Total Orders (Count)",
    "mine_93": "Device Status",
    "mine_94": "Total Stations",
    "mine_95": "Device Analytics",
    "mine_96": "View More",
    "mine_97": "Total Gross Sales",
    "mine_98": "Total Refunds Amount",
    "mine_99": "Refunded Orders Count",
    "mine_100": "Order Count",
    "mine_101": "Valid Orders Count",
    "mine_102": "Total Order Revenue (HKD)",
    "mine_103": "Total Payout Income (HKD)",
    "mine_104": "Accumulated Elec Fee (HKD)",
    "mine_105": "Accumulated Service Fee (HKD)",
    "mine_106": "Total Devices (Units)",
    "mine_107": "Total Ports (Units)",
    "mine_108": "Total Orders (Count)",
    "mine_109": "Accumulated Energy (kWh)",
    "mine_110": "Sales Analytics",
    "mine_111": "Device Analytics",
    "mine_112": "Amount (HKD)",
    "mine_113": "Power Consumed (kWh)",
    "mine_114": "Utilization Rate",
    "mine_115": "Valid Ports",
    "mine_116": "Damaged Ports",
    "mine_117": "Past Quarter",
    "mine_118": "User",
    "mine_119": "Charging Station Name",
    "mine_120": "Order ID",
    "mine_121": "Order Amount",
    "mine_122": "Current Payout Share",
    "mine_123": "No payout records found",
    "mine_124": "Days",
    "mine_125": "Hours",
    "mine_126": "Mins",
    "mine_127": "Withdrawal ID",
    "mine_128": "Withdrawal Date",
    "mine_129": "Withdrawal Amount",
    "mine_130": "Actual Received Amount",
    "mine_131": "Withdrawal Status",
    "mine_132": "Pending Review",
    "mine_133": "Processing",
    "mine_134": "Success",
    "mine_135": "Failed",
    "mine_136": "- Withdrawal Records",
    "mine_137": "Log Out",
    "mine_138": "Withdrawal History",
    "mine_139": "Are you sure you want to log out from the current account?",
    "mine_140": "Logging out...",
    "mine_141": "Total Order Amount",
    "mine_142": "My Share Amount",
    "mine_143": "Total Charging Cost",
    "mine_144": "Total Service Fee",
    "mine_145": "Old Password",
    "mine_146": "New Password",
    "mine_147": "Confirm New Password",
    "mine_148": "The passwords entered do not match",
    "mine_149": "Please enter your old password",
    "mine_150": "Please enter your new password",
    "mine_151": "Please confirm your new password",
    "mine_152": "Password updated successfully",
    "mine_153": "Failed to update password",
    "mine_154": "Please enter withdrawal amount",
    "mine_155": "WeChat Linked",
    "mine_156": "Instant Payout",
    "mine_157": "Withdrawn successfully",
    "mine_158": "IC Card",
    "mine_159": "Please select card number",
    "mine_160": "Transfer Amount",
    "mine_161": "Please enter amount",
    "mine_162": "Account Balance",
    "mine_163": "Please enter a non-negative number",
    "mine_164": "Transferable amount cannot exceed ",
    "mine_165": "Transfer successful",
    "mine_166": "Transfer failed",
    "mine_167": "Refund History",
    "mine_168": "No users found",
    "mine_169": "All Users",
    "mine_170": "Registration Time",
    "mine_171": "Accumulated Top-ups",
    "mine_172": "Card Balance",
    "mine_173": "Transfer",
    "mine_174": "Transferable Amount",
    "mine_175": "This user does not have a prepaid card, cannot transfer",
    "mine_176": "Please enter user nickname or phone number",
    "mine_177": "Balance Amount",
    "mine_178": "Accumulated Top-up (HKD)",
    "mine_179": "Balance (HKD)",
    "mine_180": "Card Balance (HKD)",
  },
  "order":{
    "order_1": "No order data available",
    "order_2": "All Orders",
    "order_3": "Order ID",
    "order_4": "Estimated End Time",
    "order_5": "Charging Amount",
    "order_6": "Payment Status",
    "order_7": "Order Info",
    "order_8": "Order Type",
    "order_9": "Refund amount cannot exceed order amount",
    "order_10": "Please enter refund amount",
    "order_11": "Order Tracking",
    "order_12": "Group Order",
    "order_13": "No",
    "order_14": "Cost Breakdown",
    "order_15": "Electricity Cost",
    "order_16": "Coupon Discount",
    "order_17": "Station Discount",
    "order_18": "Total Elec Fee Discount",
    "order_19": "Total Service Fee Discount",
    "order_20": "Points Info",
    "order_21": "Charging Points",
    "order_22": "Parking Points",
    "order_23": "Redeemed Points",
    "order_24": "Redemption Amount",
    "order_25": "Max Points Service Fee Discount",
    "order_26": "Device Info",
    "order_27": "Station Location",
    "order_28": "User Info",
    "order_29": "Payment Info",
    "order_30": "Payment Method",
    "order_31": "Online Payment",
    "order_32": "Payment Time",
    "order_33": "Apply for Refund",
    "order_34": "Place Order",
    "order_35": "Payment Successful",
    "order_36": "Completed",
    "order_37": "Settling",
    "order_38": "Manual Settlement",
    "order_39": "Actual Amount Paid",
    "order_40": "Query by Time Range",
    "order_41": "Daily View: displays data hourly;",
    "order_42": "Date Range View: displays data daily;",
    "order_43": "Please select start date",
    "order_44": "Please select end date",
    "order_45": "Order Count",
    "order_46": "Sales Volume",
    "order_47": "End date cannot be earlier than start date",
    "order_48": "to",
    "order_49": "Port No.",
    "order_50": "Please enter charging pile port number",
    "order_51": "Energy Amount",
    "order_52": "Duration",
    "order_53": "Port Changes",
    "order_54": "Order Status",
    "order_55": "Address",
    "order_56": "Port",
    "order_57": "Actual Charging Duration",
  },
  "inuseorderdetial": {
    "briefPlaceOrder": "Order placed",
    "briefStartCharge": "Start charging",
    "briefCharging": "Charging",
    "briefEndCharge": "End charging",
    "briefChargeTerminated": "Charging terminated",
    "briefSettling": "Settling",
    "briefCompleteOrder": "Order completed",
    "traceClientRemoteStart": "Remote start charging via user app",
    "traceRemoteStart": "Remote start charging",
    "traceRemoteStartSuccess": "Remote start succeeded, charging started",
    "traceCharging": "Charging",
    "traceManualStop": "Charging stopped by user",
    "traceRemoteStop": "Remote stop",
    "traceStopped": "Charging stopped",
    "traceSettling": "Order settling",
    "traceConsumptionSuccess": "Payment successful. Amount: {amount}, Balance: {balance}",
    "traceCompleted": "Order completed"
  },
  "promotion":{
    "promotion_1": "Promotion Name",
    "promotion_2": "Threshold Amount",
    "promotion_3": "Bonus Amount",
    "promotion_4": "Status",
    "promotion_5": "Visibility",
    "promotion_6": "Normal",
    "promotion_7": "Disabled",
    "promotion_8": "Hidden",
    "promotion_9": "Visible",
    "promotion_10": "Please complete all fields before submitting",
    "promotion_11": "Updated successfully",
    "promotion_12": "Added successfully",
    "promotion_13": "New Promotion",
    "promotion_14": "Promo Threshold Amount",
    "promotion_15": "Bonus Amount",
    "promotion_16": "Created Time",
    "promotion_17": "",
    "promotion_18": "",
    "promotion_19": "",
    "promotion_20": "",
    "promotion_21": "",
    "promotion_22": "",
    "promotion_23": "",
    "promotion_24": "",
    "promotion_25": "",
    "promotion_26": "",
    "promotion_27": "",
    "promotion_28": "",
    "promotion_29": "",
    "promotion_30": "",
    "promotion_31": "",
    "promotion_32": "",
    "promotion_33": "",
    "promotion_34": "",
    "promotion_35": "",
    "promotion_36": "",
    "promotion_37": "",
    "promotion_38": "",
  },
  "response":{
    "response_1": "User Nickname",
    "response_2": "Contact Number",
    "response_3": "Issue Type",
    "response_4": "Issue Description",
    "response_5": "Submission Time",
    "response_6": "Device Name",
    "response_7": "Device ID",
    "response_8": "Port No.",
    "response_9": "Annotation / Note",
    "response_10": "Processed By",
    "response_11": "Processed Time",
    "response_12": "Add Note",
    "response_13": "Please enter note",
    "response_14": "Note added successfully",
    "response_15": "No feedback reports at the moment",
    "response_16": "All Feedback",
    "response_17": "Pending Review",
    "response_18": "Other Reasons",
    "response_19": "User Phone",
    "response_20": "Device Name",
    "response_21": "Charging Pile Code",
    "response_22": "Issue Description",
    "response_23": "No feedback records found",
    "response_24": "Feedback Status",
    "response_25": "Feedback Type",
    "response_26": "Please select feedback status",
    "response_27": "Please select feedback type",
    "response_28": "Resolved",
    "response_29": "Unresolved",
    "response_30": "Pile Code",
    "response_31": "Port No.",
    "response_32": "Other Types",
    "response_33": "Feedback Time",
    "response_34": "Processing Info",
    "response_35": "Processing Notes",
    "response_36": "Submitted successfully",
  },
  "rules":{
    "rules_1": "Rule Name",
    "rules_2": "Please enter billing rule name",
    "rules_3": "Fee Configuration",
    "rules_4": "Note: Rates for Sharp, Peak, Flat, and Valley slots are all required. Please fill according to local utility rates.",
    "rules_5": "Electricity Fee (HKD/kWh)",
    "rules_6": "Service Fee (HKD/kWh)",
    "rules_7": "24-Hour Electricity Tariff Period Settings",
    "rules_8": "Note: Min time interval is 30 mins; up to 48 billing periods can be configured.",
    "rules_9": "Time Slot",
    "rules_10": "Rate Type",
    "rules_11": "Add",
    "rules_12": "Option Display Mode",
    "rules_13": "Payment Selection Page for EV Owners",
    "rules_14": "Enable Smart Full-Charge Cut-Off",
    "rules_15": "Duration",
    "rules_16": "Amount",
    "rules_17": "Energy",
    "rules_18": "Select Time",
    "rules_19": "Sharp Slot",
    "rules_20": "Peak Slot",
    "rules_21": "Flat Slot",
    "rules_22": "Valley Slot",
    "rules_23": "Please fill in all required fields",
    "rules_24": "Start time and end time cannot be the same",
    "rules_25": "Start time cannot be later than end time",
    "rules_26": "Time periods must be continuous",
    "rules_27": "You can set a maximum of 48 time periods",
    "rules_28": "Duration (h)",
    "rules_29": "Fee (HKD)",
    "rules_30": "Unit Price / h",
    "rules_31": "Category",
    "rules_32": "Fee Type",
    "rules_33": "Created Time",
    "rules_34": "No rule price records found",
    "rules_35": "Create New Price Rule",
    "rules_36": "Billing Model",
    "rules_37": "Please enter billing model",
    "rules_38": "Fixed Rate",
    "rules_39": "Please enter type",
    "rules_40": "Duration",
    "rules_41": "Please enter duration",
    "rules_42": "Please enter unit price",
    "rules_43": "Please enter fee",
    "rules_44": "Overtime",
    "rules_45": "Rule Exceeds Custom Threshold",
    "rules_46": "Overtime Price",
    "rules_47": "Price When Rule Exceeds Custom Threshold",
    "rules_48": "Please select billing model",
    "rules_49": "Please select type",
    "rules_50": "Edit Price Rule",
    "rules_51": "Custom Duration",
    "rules_52": "Duplicate this rule?",
    "rules_53": "Price rule duplicated successfully",
    "rules_54": "Cancel Duplication",
    "rules_55": "Price rule added successfully",
    "rules_56": "Price rule updated successfully",
    "rules_57": "Are you sure you want to delete?",
    "rules_58": "Deleted successfully",
    "rules_59": "Cancel Deletion",
    "rules_60": "Hourly Billing",
    "rules_61": "No rule data available at the moment",
    "rules_62": "All Rules",
    "rules_63": "Linked Devices",
    "rules_64": "Copy",
    "rules_65": "Duplicate Rule",
    "rules_66": "Are you sure you want to delete this billing rule?",
    "rules_67": "Let me think",
    "rules_68": "Please enter rule name",
    "rules_69": "Rule duplicated successfully",
    "rules_70": "Please enter rule name",
    "rules_71": "Failed to duplicate rule",
    "rules_72": "Cancelled rule duplication",
    "rules_73": "Confirm deletion?",
    "rules_74": "Failed to delete",
    "rules_75": "Please enter rule details",
    "rules_76": "Default Rule",
    "rules_77": "No rules available",
    "rules_78": "Please enter new rule name",
    "rules_79": "Rule name cannot be empty",
    "rules_80": "Rule Settings",
    "rules_81": "Add Rule",
    "rules_82": "Rule set successfully",
    "rules_83": "Edit Rule",
    "rules_84": "Failed to add price rule",
    "rules_85": "Please enter duration as a numeric value",
    "rules_86": "Please enter unit price as a numeric value",
    "rules_87": "Failed to modify price rule",
    "rules_88": "Station Name",
    "rules_89": "Vendor / Supplier",
    "rules_90": "User Charging Duration Options Config",
    "rules_91": "Mini Program User Charging Duration Config",
    "rules_92": "+ Add Duration Option",
    "rules_93": "Billing Configurations",
    "rules_94": "Hourly Billing",
    "rules_95": "Metered Billing (by kWh)",
    "rules_96": "Power-tiered Billing",
    "rules_97": "Unrestricted Power",
    "rules_98": "Power Band Range",
    "rules_99": "Amount",
    "rules_100": "HKD/Hr",
    "rules_101": "Service Fee Config",
    "rules_102": "HKD/kWh",
    "rules_103": "Billing Policy: Actual Energy Consumed * (Electricity Fee + Service Fee)",
    "rules_104": "+ Add Power Tier",
    "rules_105": "Billing Mode",
    "rules_106": "Failed to edit the rule",
    "rules_107": "Cost (HKD/kWh)",
    "rules_108": "Cost price must be less than or equal to the electricity fee",
  },
  "site":{
    "site_1": "Station Name",
    "site_plotNature": "Site Nature",
    "site_plotNature_1": "Public",
    "site_plotNature_2": "Workplace",
    "site_plotNature_3": "Residential",
    "site_agent": "Affiliated Agent",
    "site_agent_placeholder": "Please select an affiliated agent",
    "site_2": "Please enter station name",
    "site_3": "Location Region",
    "site_4": "Province / City / District",
    "site_5": "Location Picker",
    "site_6": "Select Location",
    "site_7": "Site Image",
    "site_8": "Parking Information",
    "site_9": "Parking Fee Type",
    "site_10": "Paid Parking",
    "site_11": "Free Parking",
    "site_12": "Receipt Support",
    "site_13": "Not Supported",
    "site_14": "Supported",
    "site_15": "Amenities",
    "site_16": "Free Wi-Fi",
    "site_17": "Convenience Store",
    "site_18": "Car Wash",
    "site_19": "Restroom",
    "site_20": "Contact Person",
    "site_21": "Please enter manager name",
    "site_22": "Contact Phone",
    "site_23": "Please enter an 11-digit mobile number",
    "site_24": "Support Plug&Charge",
    "site_25": "Not Supported",
    "site_26": "Supported",
    "site_27": "Operational Status",
    "site_28": "Closed",
    "site_29": "Open",
    "site_30": "Business Hours",
    "site_31": "Opening Time",
    "site_32": "Closing Time",
    "site_33": "Show in App",
    "site_34": "Hide",
    "site_35": "Show",
    "site_36": "Select Region",
    "site_37": "Please select time",
    "site_38": "Photo Gallery",
    "site_39": "Please enter station name",
    "site_40": "Length must be between 3 and 10 characters",
    "site_41": "Feature unavailable",
    "site_42": "Upload failed",
    "site_43": "Only JPG / PNG formats are supported!",
    "site_44": "Image size cannot exceed 2MB!",
    "site_45": "Please fill in all complete fields before submitting",
    "site_46": "Please enter an 11-digit phone number",
    "site_47": "Please enter a valid phone number format",  
    "site_48": "Updated successfully",
    "site_49": "Added successfully",
    "site_50": "Failed to add",
    "site_51": "You haven't added any charging stations yet",
    "site_52": "Please click the 'Add Charging Station' button below",
    "site_53": "to start your operations!",
    "site_54": "All Stations",
    "site_55": "Location",
    "site_56": "Search Location",
    "site_57": "Beijing Municipal Government",
    "site_58": "Basic Information",
    "site_59": "Community Name",
    "site_60": "Detailed Address",
    "site_61": "Please enter detailed address",
    "site_62": "Add Image",
    "site_63": "Please enter community name",
    "site_64": "All Communities",
    "site_65": "Add New Community",
    "site_66": "Station ID",
    "site_67": "Enable Points Deduction",
    "site_68": "Enable Departure Bonuses",
    "site_69": "Enable Charging Rewards",
    "site_70": "Please enter station ID",
    "site_71": "Yes",
    "site_72": "No",
    "site_73": "Please enter a phone number",
    "site_74": "",
    "site_75": "",
    "site_76": "",
    "site_77": "Occupancy Fee Settings",
    "site_78": "Sharing Settings",
    "site_79": "Enable Occupancy Fee",
    "site_80": "Free Occupancy Time",
    "site_81": "Charge Rate",
    "site_82": "Cap Amount",
    "site_83": "min",
    "site_84": "HKD/min",
    "site_85": "",
    "site_86": "Enter free occupancy time",
    "site_87": "Enter charge rate",
    "site_88": "Enter cap amount",
    "site_89": "Occupancy fee saved",
    "site_90": "Failed to save occupancy fee",
    "site_91": "Failed to load occupancy fee config",
    "site_92": "Site Sharing Settings",
    "site_93": "Operator Name",
    "site_94": "Sharing Type",
    "site_95": "Select sharing type",
    "site_96": "Operator Ratio (%)",
    "site_97": "Platform Ratio (%)",
    "site_98": "Electricity",
    "site_99": "Service Fee",
    "site_100": "Electricity + Service Fee",
    "site_101": "Sharing settings saved",
    "site_102": "Failed to save sharing settings",
    "site_103": "Payee",
    "site_104": "Electricity Profit Ratio (%)",
    "site_105": "Electricity Cost Ratio (%)",
    "site_106": "Service Fee Ratio (%)",
    "site_107": "Remark",
    "site_108": "Electricity profit ratios do not sum to 100",
    "site_109": "Electricity cost ratios do not sum to 100",
    "site_110": "Service fee ratios do not sum to 100",
    "site_111": "Enter operator ratio",
    "site_112": "Auto-calculated",
    "site_113": "Tip 1: Only integers are allowed (e.g. 60 means 60%). If no third party needs a share, set 100% to the site owner.",
    "site_114": "Tip 2: The sum of all sharing ratios must equal 100.",
    "site_115": "Tip 3: Electricity profit = electricity fee - electricity cost;",
    "site_116": "HKD",
  },
  "admin":{
    "admin_1": "Home",
    "admin_2": "Me",
    "admin_3": "Operations",
    "admin_4": "Your operator profile has not configured Official Account information correctly",
    "admin_5": "Revenue Sharing Details",
    "admin_6": "Order",
    "admin_7": "Order Details",
    "admin_8": "Refund",
    "admin_9": "Edit Order",
    "admin_10": "View Earnings",
    "admin_11": "IC Card",
    "admin_12": "Card Recharge Records",
    "admin_13": "Card Usage Records",
    "admin_14": "Feedback",
    "admin_15": "Feedback Details",
    "admin_16": "Balance Details",
    "admin_17": "Bind WeChat",
    "admin_18": "Account Settings",
    "admin_19": "Language",
    "admin_20": "Withdrawal Records",
    "admin_21": "Device",
    "admin_22": "Edit Device",
    "admin_23": "Add Device",
    "admin_24": "Device Port",
    "admin_25": "User",
    "admin_26": "Transfer",
    "admin_27": "Rule",
    "admin_28": "Select Rule",
    "admin_29": "Edit Rule",
    "admin_30": "Station",
    "admin_31": "Community",
    "admin_32": "Add/Edit Station",
    "admin_33": "Advertisement",
    "admin_34": "Add/Edit Advertisement",
    "admin_35": "Promotion",
    "admin_36": "Add/Edit Promotion",
    "admin_37": "Withdrawal",
    "admin_38": "User Recharge Records",
    "admin_39": "Add/Edit Card",
    "admin_40": "Issue Details",
    "admin_41": "User Agreement",
    "admin_42": "Share Sum"

  },
  "common": {
    "cancel": "Cancel",
    "confirm": "Confirm",
    "edit": "Edit",
    "delete": "Delete",
    "noData": "No Data",
    "back": "Back",
    "success": "Action Successful",
    "failed": "Action Failed",
    "noMore": "No More",
    "search": "Search",
    "tip": "Tip",
    "submit": "Submit",
    "add": "Add New"
  }
};